module.exports = __webpack_public_path__ + "static/step5-5334654ada1e6cd40257ee6ba1166f25.svg";